import { useEffect } from 'react';

/**
 * Custom hook to detect clicks outside an element
 * @param {Function} handler - Function to call when clicking outside
 * @param {boolean} active - Whether the handler is active
 * @param {string} className - Class name to check for
 */
export const useClickOutside = (handler, active, className) => {
  useEffect(() => {
    if (!active) return;

    const handleClickOutside = (event) => {
      if (!event.target.closest(`.${className}`)) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handler, active, className]);
};

